// extracted by mini-css-extract-plugin
export var container = "_co-0";
export var outlet = "_co-1";
export var outletEnter = "_co-2";
export var outletEnterActive = "_co-3";
export var outletExit = "_co-4";
export var outletExitActive = "_co-5";